import { render, staticRenderFns } from "./SSOLogin.vue?vue&type=template&id=7dd268dd&scoped=true"
import script from "./SSOLogin.vue?vue&type=script&lang=js"
export * from "./SSOLogin.vue?vue&type=script&lang=js"
import style0 from "./SSOLogin.vue?vue&type=style&index=0&id=7dd268dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd268dd",
  null
  
)

export default component.exports